export default __webpack_public_path__ + "static/media/1-ab.4afb7329.jpg";